import { QueryClient } from '@tanstack/react-query'

// Auth failures won't fix themselves on retry — don't hammer a dead/expired token.
const isAuthError = (error) => {
  const status = error?.status ?? error?.response?.status
  return status === 401 || status === 403
}

// Single, shared client. Defaults tuned for a game UI: no surprise refetch when
// the player alt-tabs back, short freshness window, and no retry storms on auth.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => !isAuthError(error) && failureCount < 2,
    },
  },
})
